import { render, staticRenderFns } from "./batchBindModal.vue?vue&type=template&id=a8967ce6&scoped=true"
import script from "./batchBindModal.vue?vue&type=script&lang=js"
export * from "./batchBindModal.vue?vue&type=script&lang=js"
import style0 from "./batchBindModal.vue?vue&type=style&index=0&id=a8967ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8967ce6",
  null
  
)

export default component.exports